import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { LoginCallback, loginSaml, loginSamlCode, logout } from 'store/actions/authActions';
import { useDispatch } from '../../store';

export default function SamlHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const passwordRef = useRef<HTMLInputElement>(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Código de uso único gerado pelo samlAcs (fluxo novo).
    const code = params.get('code');

    // Fluxo antigo, mantido enquanto o backend ainda envia token + userIdentifier.
    const token = params.get('token');
    const username = params.get('userIdentifier');
    const networkId = params.get('networkId');

    if (!code && (!token || !username || !networkId)) {
      console.log('Parâmetros faltando no callback SAML');
      setError('missing_params');
      setLoading(false);
      return;
    }

    dispatch(logout());

    sessionStorage.clear();
    localStorage.removeItem('deviceToken');

    const loginCallback: LoginCallback = (succeded, { message, response }) => {
      setLoading(false);

      if (succeded) {
        const redirectTo = sessionStorage.getItem('redirect_to');

        // replace: a URL do callback (com o código) não fica no histórico do navegador.
        if (redirectTo) {
          navigate(redirectTo, { replace: true });
          sessionStorage.removeItem('redirect_to');
          return;
        }

        navigate('/', { replace: true });
        return;
      }

      passwordRef.current?.select();

      let err = 'generic';
      if (response) err = String(response.status);
      else if (message.toLowerCase() === 'network error') err = 'network';
      else if (message.toLowerCase().includes('recaptcha')) err = 'recaptcha';

      setError(err);
    };

    const hasLegacyParams = !!token && !!username && !!networkId;

    const loginLegacySaml = () => {
      const loginData: LoginData = {
        userName: username as string,
        networkId: networkId as string,
        password: '',
        recaptchaToken: '',
      };

      dispatch(loginSaml(loginData, loginCallback));
    };

    if (code) {
      dispatch(
        loginSamlCode(code, (succeded, args) => {
          // Transição: se o código falhar e o backend ainda mandou o formato antigo, usa ele.
          if (!succeded && hasLegacyParams) {
            loginLegacySaml();
            return;
          }

          loginCallback(succeded, args);
        })
      );
      return;
    }

    loginLegacySaml();
  }, [location, dispatch, navigate]); // 🔥 agora roda quando network chegar

  if (loading) return <div>Autenticando...</div>;
  if (error) return <div>Erro ao autenticar: {error}</div>;

  return <div>Redirecionando...</div>;
}
